if(!customElements.get("image-banner")) {
  customElements.define("image-banner", class ImageBanner extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      // initiate slider
      const sliderElement = this.querySelector(".image-banner__slider");
      const heroSlider = new Swiper(sliderElement, {
        slidesPerView: 1,
        navigation: {
          prevEl: ".swiper-arrow-prev",
          nextEl: ".swiper-arrow-next"
        },
        loop: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        }
      });
    }
  });
}
